import { useEffect, useContext } from 'react'
import { FieldPageContext } from './context'

const noop = () => null

const useFieldPageContext = ({ onBack = noop, onSubmit = noop } = {}) => {
  const context = useContext(FieldPageContext)

  useEffect(() => {
    context.setHandlers({
      onBack,
      onSubmit,
    })
  }, [onBack, onSubmit])

  return context
}

export { useFieldPageContext }
